export function setRandomFavicon() {
  // Mondrian palette (no white)
  const COLORS = ["#e53935", "#1e3a8a", "#f1c40f"];
  const color = COLORS[Math.floor(Math.random() * COLORS.length)];

  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
  <g fill="none" fill-rule="evenodd">
    <rect x="0"   y="0"  width="26" height="128" fill="${color}"/>
    <rect x="34"  y="0"  width="26" height="128" fill="${color}"/>
    <rect x="68"  y="0"  width="26" height="60"  fill="${color}"/>
    <rect x="68"  y="68" width="26" height="60"  fill="${color}"/>
    <rect x="102" y="0"  width="26" height="60"  fill="${color}"/>
  </g>
</svg>`.trim();

  const href = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);

  // IMPORTANT:
  // Only target a generic favicon link WITHOUT sizes
  // This ensures we never touch Google-visible static icons
  let link = document.querySelector<HTMLLinkElement>(
    'link[rel="icon"]:not([sizes])'
  );

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.type = "image/svg+xml";
  link.href = href;
}
